module.exports = __webpack_public_path__ + "media/src/images/icons/white-copy-075a492e99b0c8d90891910ecdbc6844.svg";